import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { HelperService } from '../../../service/helper.service';
import { CustomerManageOrdersService } from '../../../service/cutomer-manage-order.service';
import * as FileSaver from "file-saver";
import { orderStatusApproveRejet } from '../order-management-model';

@Component({
    selector: 'app-view-order-history',
    templateUrl: './view-order-history.component.html',
    styleUrls: ['./view-order-history.component.scss']
})

export class ViewOrderHistoryComponent implements OnInit {
    displayedColumns: string[] = ['name', 'status','creted at'];
    dataSource:any;
    title = 'ORDERMANAGEMENT.ViewLabel';
    customerDetails: any;
    status = null
    customerId: any;
    country = [];
    countryRecordFiltered = [];
    region = [];
    getResionId: any;
    countryName: any;
    resionName: any;
    taskOrActivities: any;
    documentInputs: any;
    signedContractPdf: any;
    orderStatusApproveRejet = orderStatusApproveRejet;
    @Input() planning = false;
    sidebarMenuName: string;
    constructor(public dialog: MatDialog,
        private helper: HelperService,
        private translate: TranslateService,
        private route: ActivatedRoute,
        private ApiServiceOrder: CustomerManageOrdersService,
        private router: Router) {

    }

    ngOnInit(): void {
        this.sideMenuName()
        const id = this.route.snapshot.paramMap.get('id');
        this.customerId = this.route.snapshot.paramMap.get('id');
        if (id) {
            this.getDetails(id)
        }
    }

    sideMenuName() {
        this.sidebarMenuName = this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.title'),
        this.helper.sideMenuListName.next(this.sidebarMenuName);
      }

    getDetails(id) {
        this.ApiServiceOrder.getOrderDetails(id).subscribe((res: any) => {
            if (res.result && res.data) {
                this.customerDetails = res.data;
                this.status = this.customerDetails.status;
                this.dataSource = this.customerDetails.rejectReason
                this.getResionId = this.customerDetails.region;
                this.helper.toggleLoaderVisibility(false);
                this.getDetailsuploadFile(res.data.attachments);
                this.getSignedContractPdfuploadFile(res.data.signedContractPdfFileName);
                this.taskOrActivities = this.customerDetails.taskOrActivties.split('\n').filter(task => task.trim() !== '');
            } else {
                this.helper.toggleLoaderVisibility(false);
                swal.fire(
                    '',
                    this.translate.instant(res.reason),
                    'info'
                );
            }
        });
    }


    getDetailsuploadFile(filesIds) {
        const payload = {
            fileIds: filesIds,
        };
        if (filesIds) {
            this.ApiServiceOrder.getFileDetailsByIds(payload).subscribe((data: any) => {
                if (data) {
                    this.documentInputs = data.data;
                    console.log('this.documentInputs', this.documentInputs)
                }

            }, (error) => {

            });
        }
    }

    downloadImageFile(id: any, name: any): void {
        this.helper.toggleLoaderVisibility(true);
        this.ApiServiceOrder.downloadFile(id).subscribe((res: any) => {
            const blob = new Blob([res], { type: 'application/pdf' });
            //this.url = window.URL.createObjectURL(blob);
            FileSaver.saveAs(blob, name);
            this.helper.toggleLoaderVisibility(false);
        }, error => {
        });
    }

    formatBytes(bytes: number): string {
        const UNITS = ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const factor = 1024;
        let index = 0;
        while (bytes >= factor) {
            bytes /= factor;
            index++;
        }
        return `${parseFloat(bytes.toFixed(2))} ${UNITS[index]}`;
    }

    getSignedContractPdfuploadFile(filesIds) {
        const payload = {
            fileIds: filesIds,
        };
        if (filesIds) {
            this.ApiServiceOrder.getFileDetailsByIds(payload).subscribe((data: any) => {
                if (data) {
                    this.signedContractPdf = data.data;
                }
            }, (error) => {

            });
        }
    }
    viewPdf(id: any, name: any): void {
        console.log('id', id);
        this.helper.toggleLoaderVisibility(true);
        this.ApiServiceOrder.downloadFile(id).subscribe((res: any) => {
            const blob = new Blob([res], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url); // Open the PDF in a new tab
            this.helper.toggleLoaderVisibility(false);
        }, error => {
            console.error('Error downloading file:', error);
            this.helper.toggleLoaderVisibility(false);
        });
    }


}
